

import React from "react";

const AuditStream = () => (
  <div>
    <h4>Audit Stream</h4>
  </div>
);

export default AuditStream;

// import { useContext } from "react";
// import { ContextEngine } from "../../../engine/ContextEngine";

// const AuditStream = () => {
//   const { context } = useContext(ContextEngine);

//   return (
//     <div>
//       <h4>Audit Stream</h4>
//       {context.events.map((e, i) => (
//         <div key={i}>{e.type}</div>
//       ))}
//     </div>
//   );
// };

// export default AuditStream;

